import { ChallengeBannersFormValues } from '../../../interfaces/ChallengeFormValues';
import { ChallengeBannersSection } from '../../../interfaces/SaveChallengeInfo';

export const convertBannersToApiFormat = (
  banners: ChallengeBannersFormValues,
): ChallengeBannersSection => {
  return {
    webBannerId: banners.webBanner?.id ?? null,
    mobileBannerId: banners.mobileBanner?.id ?? null,
  };
};
